module.exports = __webpack_public_path__ + "static/media/subICloud2.9a2f2826.png";